module.exports = __webpack_public_path__ + "static/person-d0435b1538f9da34bb013d30e76c7a25.png";